import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { CompareResponse } from 'icreate/common/models/channel-compare';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChannelCompareService {
    private domain: string;
    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    public getChannelDiff(
        vesselId: string,
        vesseliApi: string,
        shipyardiApi: string,
        version: string
    ): Promise<CompareResponse> {
        const param = { vesselId, shipyardiApi, vesseliApi, version };

        return lastValueFrom(
            this.http.get<CompareResponse>(`${this.domain}/api/channels/compare`, {
                params: param,
            })
        );
    }
}
